import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
const CreativeDirector = lazy(() => import("./CreativeDirector").then(module => ({ default: module.CreativeDirector })));
import type { CreativeDirectorProps } from "./creative-model";
import type { AudioAnalysisProps } from "./AudioAnalysis";
const AudioAnalysis = lazy(() => import("./AudioAnalysis").then(module => ({ default: module.AudioAnalysis })));

export function mountCreativeDirector(slot: HTMLElement, props: CreativeDirectorProps) {
  setStudioView("creative-director", `creative-director:${props.project.id}`, <CreativeDirector key={`${props.project.id}:${props.project.creative_brief?.source_hash || "draft"}`} {...props} />);
}
const Preproduction = lazy(() => import("./Preproduction").then(module => ({ default: module.Preproduction })));
export function mountPreproduction(props: import("./Preproduction").PreproductionProps) {
  setStudioView("preproduction", `preproduction:${props.projectId}`, <Preproduction key={props.projectId} {...props} />);
}
export function mountAudioAnalysis(slot: HTMLElement, props: AudioAnalysisProps) {
  setStudioView("stage", `audio-analysis:${props.project.id}`, <AudioAnalysis key={props.project.id} {...props} />);
}
